import * as THREE from 'three';

export default class SelectObject{
	constructor(camera, scene, outlinePass) {
		this.camera = camera;
		this.scene = scene;
		this.outlinePass = outlinePass;
		this.selectedObject = [];
		this.raycaster = new THREE.Raycaster();
		this.controlPressed = false;
		window.addEventListener("keydown", this.OnPressKey.bind(this));
		window.addEventListener("keyup", this.OnUnPressKey.bind(this));
	}

	OnPressKey(event) {
		if (event.key === "Control") {
			this.controlPressed = true;
	    }
	}

	OnUnPressKey(event) {
		if (event.key === "Control") {
			this.controlPressed = false;
	    }
	}

	CheckRaycast(mousePos) {
		this.raycaster.setFromCamera( mousePos, this.camera );

		const intersects = this.raycaster.intersectObjects( this.scene.children, true);
		
		for (var i = 0; i < intersects.length; i++) {
			if (intersects[i] != this.scene && intersects[i].object.name != "Line" && intersects[i].object.name != "Texte") {
				var objectGet = this.GetObjectMoveData(intersects[i].object);
				if (objectGet.visible) {
					if (this.controlPressed) {
						if (objectGet != null) {
							if (this.selectedObject.includes(objectGet)) {
								this.selectedObject = this.selectedObject.filter(obj => obj != objectGet);
							}
							else {
								this.selectedObject.push(objectGet);
							}
						}
					}
					else {
						this.selectedObject = [objectGet];
						if (this.selectedObject[0] == null)
							this.selectedObject = [];
					}

					break;
				}
			}
		}
		
		this.OutlineSelect();
		this.UpdateUIDataOnSelect();
		return this.selectedObject;
	}

	SelectRange(data) {
		var newSelectObjects = [];
		var listObjects = this.GetChildrenSameType();
		var invertRange = false;
		if (this.selectedObject.length > 0) {
			invertRange = this.selectedObject[0].rotation.y%Math.PI==0?false:true;
		}

		for (var i = 0; i < this.selectedObject.length; i++) {
			if (!data.range) {
				for (var j = 0; j < listObjects.length; j++) {
					if (invertRange) {
						if (listObjects[j].position.z == this.selectedObject[i].position.z) {
							newSelectObjects.push(listObjects[j]);
						}
					}
					else {
						if (listObjects[j].position.x == this.selectedObject[i].position.x) {
							newSelectObjects.push(listObjects[j]);
						}
					}
				}
			}
			else if (data.range) {
				for (var j = 0; j < listObjects.length; j++) {
					if (invertRange) {
						if (listObjects[j].position.x == this.selectedObject[i].position.x) {
							newSelectObjects.push(listObjects[j]);
						}
					}
					else {
						if (listObjects[j].position.z == this.selectedObject[i].position.z) {
							newSelectObjects.push(listObjects[j]);
						}
					}
				}
			}
		}
		this.selectedObject = newSelectObjects;
		this.OutlineSelect();
		this.UpdateUIDataOnSelect();

		return this.selectedObject;
		
	}

	GetObjectMoveData(obj) {
		if (obj == this.scene) {
			return null;
		}
		else if (this.IsMoveDataObject(obj)) {
			return obj;
		}
		return this.GetObjectMoveData(obj.parent);
	}

	IsMoveDataObject(obj) {
		return obj.hasOwnProperty("simsData");
	}

	GetChildrenSameType() {
		var listObject = [];
		for (var i = 0; i < this.scene.children.length; i++) {
			if (this.IsMoveDataObject(this.scene.children[i]) && this.scene.children[i].name == this.selectedObject[0].name) {
				listObject.push(this.scene.children[i]);
			}
		}
		return listObject;
	}

	ResetSelection() {
		this.selectedObject = [];
		this.OutlineSelect();
		return this.selectedObject;
	}

	OutlineSelect() {
		this.outlinePass.selectedObjects = this.selectedObject;
	}

	UpdateUIDataOnSelect() {
		if (this.selectedObject.length > 0) {
			var element;
			var dataToChange = {rot: true};
			for (var i = 0; i < this.selectedObject.length; i++) {
				if (i == 0) {
					dataToChange.rotY = this.selectedObject[i].rotation.y;
				}
				else {
					if (dataToChange.rotY != this.selectedObject[i].rotation.y) {
						dataToChange.rot = false;
					}
				}
			}

			element = document.getElementById("rotationSelection");
			if (dataToChange.rot) {
				element.value = this.RadiantToDegree(dataToChange.rotY)%360;
			}
			else {
				element.value = null;
			}
		}
	}

	RadiantToDegree(value) {
		return value * (180 / Math.PI);
	}
}